import styled from 'styled-components';
import Container from '../../components/Container';

export const Breadcrumb = styled.div`
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  padding: 16px 0;
  
  @media screen and (max-width: 768px) {
    padding: 16px 32px;
  }
  
  @media screen and (max-width: 414px) {
    padding: 19px 16px;
  }
`;

export const BreadcrumbContainer = styled(Container)`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: #48515D;
  
  > i {
    font-style: normal; 
    margin: 0 20px;
  }
`;

export const TableContainer = styled(Container)`
  margin: 60px auto;
  
  .table-tle {
    font-size: 14px;
    line-height: 20px;
    color: #212833;
    margin-bottom: 20px;
  }
  
  .bnc-table-placeholder {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .bnc-table td { 
    padding: 13px 20px;
  }
  
  .pre-login {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    padding: 20px 20px;
    
    .no-icon {
      width: 88px;
      height: 88px;
      background: url(${require('./images/frame.png')}) no-repeat center/100%;
    }
    
    > p { 
      margin: 20px auto 0;
      font-size: 14px;
      height: 22px;
      line-height: 22px;
      
      > a { color: #F0B90B; }   
    }
  }
  
  @media screen and (max-width: 768px) {
    padding: 0 32px;
  }
  
  @media screen and (max-width: 414px) {
    margin: 40px 0 120px;
    padding: 0 16px;
    
    .bnc-table-body {
      &::-webkit-scrollbar {
        height: 4px;
      }
      
      &::-webkit-scrollbar-track {
        border-radius: 100px;
      }
    }
    
    .bnc-table th {
      padding: 11px 10px;
    }
    
    .bnc-table td { 
      padding: 13px 10px;
    }
    
    .pre-login .no-icon {
      width: 66px;
      height: 66px;
    }
  }
`;
